import { render, staticRenderFns } from "./AddWorkerDialog.vue?vue&type=template&id=b93f2122&"
import script from "./AddWorkerDialog.vue?vue&type=script&lang=js&"
export * from "./AddWorkerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports